import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'id',
  },
  created_at: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'datetime',
  },
  bank_account: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'string',
  },
  bank_name: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'string',
  },
  company_address: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'string',
  },
  tax_number: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'string',
  },
  telephone: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'string',
  },
  title: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'string',
  },
  invoice_type: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'enum',
  },
  state: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'enum',
  },
  title_type: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'enum',
  },
  user: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  user_id: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  apply_record: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'apply_record',
      model_name: 'ApplyRecord',
      foreign_key: 'apply_record_id',
    },
  },
  apply_record_id: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'apply_record',
      model_name: 'ApplyRecord',
      foreign_key: 'apply_record_id',
    },
  },
  remark: {
    model_name: 'InvoiceApplyRecord',
    column_type: 'text',
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
